import { css } from 'styled-components';

export const boldText = css`
  font-family: Walsheim-Bold, sans-serif;
`;
